"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.delegateTokenIntents = void 0;

var _tokenIntents = require("./../../token-intents");

const delegateTokenIntents = elements => class BasisTheoryTokenIntentsElementsDelegate extends _tokenIntents.BasisTheoryTokenIntents {
  create(payload, requestOptions) {
    if (elements !== null && elements !== void 0 && elements.hasElement(payload)) {
      return elements.tokenIntents.create(payload, requestOptions);
    }

    return super.create(payload, requestOptions);
  }

};

exports.delegateTokenIntents = delegateTokenIntents;